import { BUSINESS_LIST_LIMIT } from "contexts/business-compliance-context";

import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

export const COLORS = ["#009642", "#F49D1B", "#004300", "#656565", "#A432B1"];
const INDEX_OFFSET = 1;
export const COLORS_MAX_LENGTH_INDEX = COLORS.length - INDEX_OFFSET;
export const BUSINESSES_COMPLIANCE_LIST_PAGINATION_PARAMS: IPaginationParams = {
  page: PAGE_ONE,
  limit: BUSINESS_LIST_LIMIT,
};
